<template>
  <b-card bg-variant="light"
          header="Trainings"
          header-bg-variant="dark"
          header-text-variant="white">
    <b-tabs v-model="selectedCard" card>

      <b-tab lazy title="User list">
        <users-trainings-list :fields="userTrainingsFields"/>
      </b-tab>

    </b-tabs>
  </b-card>
</template>

<script>
  import UsersTrainingsList from '@/components/operational/trainings/UsersTrainingsList';
  import { ordinalNumber } from '@/helpers/commonTableColumns';

  export default {
    name: 'TrainingsDashboard',
    components: { UsersTrainingsList },
    data() {
      return {
        selectedCard: 1,
        userTrainingsFields: [
          ordinalNumber,
          {
            key: 'first_name',
            label: 'Name',
          },
          {
            key: 'last_name',
            label: 'Surname',
          },
          {
            key: 'email',
            label: 'Email',
          },
          {
            key: 'training_data.safety_training',
            label: 'Training valid through',
          },
          {
            key: 'training_data.safety_training.states.state',
            label: 'Safety training (true/false)',
          },
          { key: 'actions' },
        ],
      };
    },
  };
</script>

<style scoped>
  .card {
    margin: 2rem;
  }
</style>
